const linkLandingPagesValidationHR = {
    "add": {
        "title": {
            "required": "Naslov je obavezan",
            "length": "Naslov ne može biti duži od 32 znaka"
        },
        "short_description": {
            "length": "Opis ne može biti duži od 80 znakova."
        },
        "back_url": {
            "required": "Povratni URL je obavezan",
            "length": "Povratni URL ne može biti duži od 10 znakova",
            "unique": "Ups! Ovaj povratni URL je već povezan s drugom odredišnom stranicom. Molimo pokušajte s drugim povratnim URL-om.",
            "available": "Povratni URL je dostupan",
            "invalid": "Povratni URL je nevažeći"
        },
        "logo": {
            "required": "Logo je obavezan",
            "dimensions": "Veličina logotipa mora biti najmanje 500 X 500 px i omjer slike 1:1, podržani formati JPG/JPEG/PNG.",
            "choose": "Molimo odaberite sliku",
            "file": "Molimo prenesite JPG ili PNG formate, minimalna rezolucija 500 X 500 px i omjer slike 1:1. Maksimalna veličina 2MB"
        },
        "background_image": {
            "dimensions": "Veličina pozadinske slike mora biti najmanje 1000 X 1000 px i omjer slike 1:1, podržani formati JPG/JPEG/PNG.",
            "choose": "Molimo odaberite sliku",
            "file": "Molimo prenesite JPG ili PNG formate, minimalna rezolucija 1000 X 1000 px i omjer slike 1:1. Maksimalna veličina 5MB"
        },
        "social_link_destination_url_facebook": {
            "required": "Odredišni URL je obavezan",
            "regexp": "Nevažeći URL",
            "invalid": "Nevažeći Facebook URL"
        },
        "social_link_destination_url_instagram": {
            "required": "Odredišni URL je obavezan",
            "regexp": "Nevažeći URL",
            "invalid": "Nevažeći Instagram URL"
        },
        "social_link_destination_url_twitter": {
            "required": "Odredišni URL je obavezan",
            "regexp": "Nevažeći URL",
            "invalid": "Nevažeći Twitter URL"
        },
        "social_link_destination_url_youtube": {
            "required": "Odredišni URL je obavezan",
            "regexp": "Nevažeći URL",
            "invalid": "Nevažeći Youtube URL"
        },
        "social_link_destination_url_tiktok": {
            "required": "Odredišni URL je obavezan",
            "regexp": "Nevažeći URL",
            "invalid": "Nevažeći TikTok URL"
        },
        "social_link_destination_url_linkedin": {
            "required": "Odredišni URL je obavezan",
            "regexp": "Nevažeći URL",
            "invalid": "Nevažeći LinkedIn URL"
        },
        "social_link_destination_url_other": {
            "regexp": "Nevažeći URL"
        },
        "featured_link_title": {
            "required": "Oznaka je obavezna",
            "length": "Oznaka ne može premašiti 100 znakova"
        },
        "featured_link_destination_url": {
            "required": "Odredišni URL je obavezan",
            "regexp": "Nevažeći URL"
        }
    },
    "update": {
        "title": {
            "required": "Naslov je obavezan",
            "length": "Naslov ne može biti duži od 32 znaka"
        },
        "short_description": {
            "length": "Opis ne može biti duži od 80 znakova."
        },
        "back_url": {
            "required": "Povratni URL je obavezan",
            "length": "Povratni URL ne može biti duži od 10 znakova",
            "unique": "Ups! Ovaj povratni URL je već povezan s drugom odredišnom stranicom. Molimo pokušajte s drugim povratnim URL-om.",
            "available": "Povratni URL je dostupan",
            "invalid": "Povratni URL je nevažeći"
        },
        "logo": {
            "required": "Logo je obavezan",
            "dimensions": "Veličina logotipa mora biti najmanje 500 X 500 px i omjer slike 1:1, podržani formati JPG/JPEG/PNG.",
            "choose": "Molimo odaberite sliku",
            "file": "Molimo prenesite JPG ili PNG formate, minimalna rezolucija 500 X 500 px i omjer slike 1:1. Maksimalna veličina 2MB"
        },
        "background_image": {
            "dimensions": "Veličina pozadinske slike mora biti najmanje 1000 X 1000 px i omjer slike 1:1, podržani formati JPG/JPEG/PNG.",
            "choose": "Molimo odaberite sliku",
            "file": "Molimo prenesite JPG ili PNG formate, minimalna rezolucija 1000 X 1000 px i omjer slike 1:1. Maksimalna veličina 5MB"
        },
        "social_link_destination_url_facebook": {
            "required": "Odredišni URL je obavezan",
            "regexp": "Nevažeći URL",
            "invalid": "Nevažeći Facebook URL"
        },
        "social_link_destination_url_instagram": {
            "required": "Odredišni URL je obavezan",
            "regexp": "Nevažeći URL",
            "invalid": "Nevažeći Instagram URL"
        },
        "social_link_destination_url_twitter": {
            "required": "Odredišni URL je obavezan",
            "regexp": "Nevažeći URL",
            "invalid": "Nevažeći Twitter URL"
        },
        "social_link_destination_url_youtube": {
            "required": "Odredišni URL je obavezan",
            "regexp": "Nevažeći URL",
            "invalid": "Nevažeći Youtube URL"
        },
        "social_link_destination_url_tiktok": {
            "required": "Odredišni URL je obavezan",
            "regexp": "Nevažeći URL",
            "invalid": "Nevažeći TikTok URL"
        },
        "social_link_destination_url_linkedin": {
            "required": "Odredišni URL je obavezan",
            "regexp": "Nevažeći URL",
            "invalid": "Nevažeći LinkedIn URL"
        },
        "social_link_destination_url_other": {
            "regexp": "Nevažeći URL"
        },
        "featured_link_title": {
            "required": "Oznaka je obavezna",
            "length": "Oznaka ne može premašiti 100 znakova"
        },
        "featured_link_destination_url": {
            "required": "Odredišni URL je obavezan",
            "regexp": "Nevažeći URL"
        }
    }
};

export default linkLandingPagesValidationHR;